// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = {};

export interface StoreCheckoutInformationBoxSectionStyles {
    wrapper?: InjectableCss;
}

export const storeCheckoutInformationBoxSectionStyles: StoreCheckoutInformationBoxSectionStyles = {
    wrapper: {
        css: css`
            ${contentSpacingStyles(pxToRem(40), 0, 0)}
            ${contentSpacingStyles(pxToRem(40), 0, 0, 0, "padding")}
            border-top: ${pxToRem(1)} solid ${getColor("common.border")};

            @media print {
                padding: ${pxToRem(5)};
                margin-top: ${pxToRem(5)};
            }
            &:first-child {
                border-top: none;
            }
        `,
    },
};

const styles = storeCheckoutInformationBoxSectionStyles;

const StoreCheckoutInformationBoxSection: FC<Props> = ({ children }) => {
    return <StyledWrapper {...styles.wrapper}>{children}</StyledWrapper>;
};

export default StoreCheckoutInformationBoxSection;
